import jobIndex from 'actions/job/index';
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import HeroLayout from 'components/UI/HeroLayout';
import React, { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DropdownCard from './components/DropdownCard';
import Filter from './components/Filter';
import './index.module.scss';

export const MatchContext = createContext(null);

const educationTypes = (job) => [
    {
        type: 'fulltime',
        value:
            job?.beschikbaarheid === 'both' ? 'fulltime' : job?.beschikbaarheid,
    },
    { type: 'structureel', value: job?.dienstverband },
    {
        type: 'parttime',
        value:
            job?.beschikbaarheid === 'both' ? 'parttime' : job?.beschikbaarheid,
    },
    { type: 'tijdelijk', value: job?.dienstverband },
    {
        type: 'tijdelijk met uitzicht op vast',
        value:
            job?.dienstverband === 'tijdelijk-uitzicht' &&
            'tijdelijk met uitzicht op vast',
    },
    {
        type: 'onderwijsondersteunende functies',
        value: job?.type === 'oop' && 'onderwijsondersteunende functies',
    },
    {
        type: 'docentenfuncties',
        value: job?.type === 'docent' && 'docentenfuncties',
    },
    {
        type: 'overig',
        value: job?.type,
    },
];

export default function Match() {
    const [searchValue, setSearchValue] = useState('');
    const [selectedSchools, setSelectedSchools] = useState([]);
    const [selectedEducationTypes, setSelectedEducationTypes] = useState([]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(jobIndex());
    }, []);

    const schools = useSelector((state) => state?.school?.entities);

    const jobs = useSelector((state) =>
        state?.job?.entities?.allIds
            ?.map((id) => ({
                ...state?.job?.entities?.byId[id],
                school:
                    schools?.byId?.[state?.job?.entities?.byId[id].school_id],
            }))
            ?.filter((job) =>
                searchValue.length
                    ? job?.name
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                    : true
            )
            ?.filter((job) => {
                if (selectedSchools.length) {
                    if (job.organisation?.schoolGroup_id) {
                        // job is attached to schoolGroup
                        return selectedSchools.includes(
                            job.organisation.school_group.name
                        );
                    }
                    return selectedSchools.includes(job.organisation?.name);
                }
                return true;
            })
            ?.filter((job) =>
                selectedEducationTypes.length
                    ? educationTypes(job).find(
                          ({ type, value }) =>
                              selectedEducationTypes.includes(type) &&
                              value === type
                      ) !== undefined
                    : true
            )
            ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
    );

    return (
        <MatchContext.Provider
            value={{
                searchValue,
                setSearchValue,
                selectedSchools,
                setSelectedSchools,
                selectedEducationTypes,
                setSelectedEducationTypes,
            }}
        >
            <Layout>
                <Container>
                    <HeroLayout>
                        <Filter />
                        {jobs?.map((e, i) => (
                            <DropdownCard
                                key={i}
                                id={e?.id}
                                employment={e?.dienstverband}
                                experience={e?.werkerveraing}
                                jobTitle={e?.name}
                                school={e?.organisation}
                                location={e?.locatie}
                                fte={e?.FTE}
                                startDate={e?.ingangsdatum}
                                availability={e?.beschikbaarheid}
                                salaray={e?.salaris}
                                richText={e?.description}
                                button={e?.button}
                            />
                        ))}
                    </HeroLayout>
                </Container>
            </Layout>
        </MatchContext.Provider>
    );
}
